import { ReactElement, ReactNode } from 'react';
import { ICloudinaryConfig } from '@cars4ever/media-utils';
import { GlobalConfig as GlobalConfigBase } from '@cars4ever/public-ui';

import { CLOUD_NAME } from '^configs/environments';
import logger from '^utils/logger';

import LayoutProvider from '../LayoutProvider';

import ErrorBoundary from './ErrorBoundary';

export interface IGlobalConfigProps {
  children: ReactNode;
}

const cloudinaryConfig: ICloudinaryConfig = {
  cloudName: CLOUD_NAME,
  handleError: ((src: string): void => {
    logger.trackError(new Error(`Failed load ${src}`), {
      catcher: 'cloudinary',
    });
  }),
};

const GlobalConfig = ({ children }: IGlobalConfigProps): ReactElement => (
  <GlobalConfigBase
    cloudinaryConfig={cloudinaryConfig}
  >
    <ErrorBoundary>
      <LayoutProvider>
        {children}
      </LayoutProvider>
    </ErrorBoundary>
  </GlobalConfigBase>
);

export default GlobalConfig;
